import CurrencyItem from './currency-item';

export default CurrencyItem;
